<template>
<v-card-actions>
  <slot name="actions">
    <v-btn @click="$emit('close')" text>{{ close_text }}</v-btn>
    <slot name="center_actions">
      <v-spacer></v-spacer>
    </slot>
    <slot name="submit">
      <v-btn color="success" @click="$emit('submit')" :disabled="disable_submit">{{ submit_text }}</v-btn>
    </slot>
  </slot>
</v-card-actions>
</template>

<script>
export default {
name: "CardActions",
  props:{
    submit_text: {
      default: 'submit'
    },
    close_text: {
      default: 'close'
    },
    disable_submit: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
